import { getFileURL } from '@/lib/helpers/FileURLGetter'
import { getTextValue } from '@/lib/helpers/LocalizedText'
export class ActivityCategory {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.name = params.name ? getTextValue(params.name) : null
    this.coverImageId = params.cover_image_id ? params.cover_image_id : null
    this.coverImageUrl = params.cover_image_id ? getFileURL(params.cover_image_id) : null
    this.facilityId = params.facility_id ? params.facility_id : null
    this.excludeFromFeaturedNextOn = params.exclude_from_featured_next_on ? params.exclude_from_featured_next_on : false
  }
}
